import {IWidgetTheme, themeTypes} from "shared-types/index";
import {Theme} from "@material-ui/core";
import {createMuiTheme} from "@material-ui/core/styles";
import {TypographyOptions} from "@material-ui/core/styles/createTypography";

const NS = 'AppThemeService';

export const DEFAULT_FONT = 'Roboto';

export default class AppThemeService {

  static useClassPrefix(): boolean {
    return true;
  }

  static getThemeDefaultPalette(): any {
    return {
      primary: {
        main: 'rgb(169,17,100)', // #a91164
        light: 'rgba(211, 137, 177,1)',
        dark: 'rgba(87, 9, 51,1)'
      },
      warning: {
        main: '#f0ad4e',
        light: '#fcf8e3',
        dark: '#8a6d3b'
      },
      success: {
        main: '#8bab67',
        light: '#c3e6cb',
        dark: '#155724'
      },
      error: {
        main: '#f44336',
        light: '#ef9a9a',
        dark: '#b71c1c'
      },
      info: {
        main: '#2196f3',
        light: '#61ade8',
        dark: '#4669ac' // this is the standby list dark blue color (also hardcoded in css)
      }
    };
  }

  /**
   * Gets the default typography styles for text.
   * Note: 'rem' units are calculated in 10's (eg '2.5rem' = '25px'), using the `htmlFontSize` value below
   * and setting it in CSS as well. This way font sizes will scale with the font settings the user has on their browser.
   */
  static getThemeDefaultTypography(): TypographyOptions {
    return {
      // Tell Material-UI what's the font-size on the html element is (src/app/containers/App/style.css)
      htmlFontSize: 10,

      h1: {
        fontSize: '3rem'
      },
      h2: {
        fontSize: '2.2rem'
      },
      h3: {
        fontSize: '1.8rem'
      },
      h4: {
        fontSize: '1.6rem'
      },
      h5: {
        fontSize: '1.4rem'
      },
      h6: {
        fontSize: '1.3rem'
      },
      subtitle1: {
        fontSize: '1.6rem'
      },
      subtitle2: {
        fontSize: '1.4rem'
      },
      body1: {
        fontSize: '1.4rem'
      },
      body2: {
        fontSize: '1.3rem'
      },
      button: {
        fontSize: '1.6rem'
      },
      caption: {
        fontSize: '1.4rem'
      },
      overline: {
        fontSize: '1.4rem'
      }
    }
  }

  static getAppThemeAsWidgetTheme(): IWidgetTheme {
    return {
      ...this.getAppTheme(),
      type: themeTypes.light,
      defaultColors: true,
      defaultFont: DEFAULT_FONT,
    }
  }

  static getAppTheme(): Theme {
    return (createMuiTheme as any)({
      palette: this.getThemeDefaultPalette(),
      overrides: {
        MuiScopedCssBaseline: {
          root: {
            backgroundColor: '#ffffff',
          },
        },
        MuiCssBaseline: {
          '@global': {
            body: {
              backgroundColor: '#ff00ff',
            },
          }
        },
      },
      typography: this.getThemeDefaultTypography()
    });
  }


  static getTestTheme(): IWidgetTheme {
    return {
      palette: this.getThemeDefaultPalette(),
      type: themeTypes.light,
      defaultColors: true,
      typography: {
        htmlFontSize: 10,
      },
      defaultFont: DEFAULT_FONT
    };
  }
}
